// Spain
export const locale = {
  lang: "es",
  data: {
    TRANSLATOR: {
      SELECT: "Elige tu idioma",
    },
    MENU: {
      NEW: "Nuevo",
      ACTIONS: "Comportamiento",
      CREATE_POST: "Crear nueva publicación",
      PAGES: "Paginas",
      FEATURES: "Caracteristicas",
      APPS: "Aplicaciones",
      DASHBOARD: "Panel de Control",
      CALENDAR: "Calendario",
      ROOMS: "Salas",
      REPORT: "Reportar Fallas",
      USERSETTINGS: "Ajustes de Usuario",
      SYSTEMSETTINGS: "Ajustes del Sistema",
      LOGOCONFIGURATION: "Configuración del Logo ",
      EMAILCONFIGURATION: "Configuración de Email ",
      EQUIPMENTS: "Equipos",
      STYLESETTINGS: "Ajustes del sistema",
      CONFIGURATIONBYLOCATION: "Configuración de Ubicaciones",
      ROOMSETTINGS: "Definiciones de Recurso",
      ACCOUNTINFORMATION: "Información de la Cuenta",
      BOOKING: "Reserva",
      CHECKOUTS: "Pagos",
      VISITORS: "Visitantes",
      VISITS: "Visitas",
      CONFIGURECUSTOMERADMIN: "Configurar el administrador de clientes",
      MRROOM: "MrRoom",
      ADMMINBACKOFFICE: "Oficina administrativa administrativa",
      ADMIN: "Administrador",
      ROLLSETTINGS: "Configuración de Funciones",
      MRVISITS: "MrVisits",
      ACCESSRIGHTS: "Permisos",
      //new
      NOCHECKOUTS: "Sin Check-Out",
      VisitsSettings: "Configuración de las Visitantes",
      ORDERS: "Pedidos",
      ORDERPENDING:"Pedidos Pendientes",
      LICENSEDASHBOARD: 'License Dashboard'
    },
    ROOMS: {
      SUNDAY: "dom",
      MONDAY: "lun",
      TUESDAY: "mar",
      WEDNESDAY: "miér",
      THURSDAY: "jue	",
      FRIDAY: "vie",
      SATURDAY: "sáb",
      LOCATION: "Ubicaciones",
      ROOMS: "Salas",
      EQUIPMENTS: "Equipos",
      STARTDATE: "Fecha de inicio",
      ENDDATE: "Fecha final",
      STARTTIME: "Hora de inicio",
      ENDTIME: "Hora de finalización",
      TIMEDURATION: "Duración",
      ALL: "Todas",
      MEETINGROOM: "Sala de Reuniones",
      DESK: "Escritorio",
      SERVICE: "Servicio",
      PLANT: "Planta",
      BOOK: "Reservar",
      SERVICES: "Servicios",
      CATERING: "Catering",
      ITSUPPORT: "Soporte Informático",
      MOBILEEQUIPMENT: "Equipos Móviles",
      SPECIAL: "Especial",
      COMMINGSOON: "en breve",
      MAPPLANT: "Mapa de la planta",
      ROOMBOOKING: "Reserva de habitacion",
      LOCATIONS: "Localización",
      RESOURCES: "Recursos",
      REQUESTERNAME: "Nombre solicitante",
      SUBJECT: "Sujeto",
      DESCRIPTION: "Descripción",
      ADDUSER: "Agregar Usuario",
      ADDVISITORS: "Agregar visitantes",
      CATERINGDESCRIPTION: "Descripción de Catering",
      MOBILEEQUIPMENTDESCRIPTION: "Descripción de Equipos Móviles",
      ITSUPPORTDESCRIPTION: "Descripción de Soporte Informático ",
      SPECIALSERVICE: "Servicios Especiales  ",
      SPECIALSERVICEDESCRIPTION: "Descripción de Servicios Especiales",
      REQUESTEREMAIL: "Correo electrónico del solicitante",
      SUMMARY: "Resumen",
      TOTALBOOKINGS: "Reservas Totales ",
      TOTALMINUTES: "Minutos Totales",
      USERS: "Usuarios",
      AVERAGEBOOKINGSTIMES: "Tiempo Medio de Reserva",
      ROOM: "Salas",
      DESKS: "Puestos",
      PARKINGSEATS: "Plazas de Aparcamiento",
      AVILABLE: "Disponible",
      FULL: "Completo",
      ROOMUSAGE: "Uso de la Sala",
      CARUSAGE: "Uso de Vehículos",
      DESKUSAGE: "Uso de lo Puesto",
      NUMBEROFBOOKINGSPERROOM: "Número de Reservas por Sala",
      NUMBEROFMINTUESPERROOM: "Número de Minutos por Sala",
      NUMBEROFMINTUESPERDESK: "Número de Reservas por Puesto",
      PARKINGSPACEUSAGE: "Uso de Plazas de Aparcamiento",
      USER: "Usuarios",
      NUMBEROFBOOKINGSPERPARKINGSEATS:
        "Número de Reservas por Plaza de Aparcamiento",
      NAME: "Nombre",
      BOOKINGS: "Reservas",
      MINTUES: "Minutos",
      ATTENDED: "Asistió",
      CANCEL: "Cancelar",
      NUMBEROFMINTESPERPARKINGSEATS:
        "Número de Minutos por Plaza de Aparcamiento",
      CHECKIN: "Check-In",
      TYPEOFBOOKING: "Tipo de reserva",
      MEETINGBEHAVIOR: "Comportamiento de reunión",
      USERTHATMISSEDCHECKIN: "Usuarios que no se han registrado",
      ENDEDASPLANING: "Terminado como cepillado",
      ENDEDONLY: "Terminó temprano",
      CANCELED: "Cancelar",
      TOTAL: "Totales",
      ACTIVE: "Activos",
    },
    ROOMBOOKING: {
      EXTENDTIMEDURATION: "Extender Duración",
      MINUTE: "Minutos",
      PINCODE: " Código PIN",
      NEWBOOKING: "Nueva reserva",
      LOCATIONS: "Ubicaciones",
      BUILDING: "Edificio",
      FLOOR: "Planta",
      RESOURCES: "Recursos",
      STARTDATE: "Fecha de inicio",
      ENDDATE: "Fecha final",
      STARTTIME: "Hora de inicio",
      ENDTIME: "Hora de Finalización",
      SELECTLOCATION: "Selecciona tu ubicación",
      SELECTBUILDING: "Elegir Edificio",
      SELECTFLOOR: "Elegir Planta",
      SELCETRESOURCE: "Elegir recursos",
      SELECTTIMEDURATION: "Elegir Duración",

      SELECTYOURROOM: "Elegir Sala de Reuniones",
      SELECTYOURDESK: "Elegir Puestos",
      SELECTCAR: "Elegir vehículo",
      CARREQUIRED: "vehículo se require",
      ROOMREQUIRED: "Sala de Reuniones se require",
      DESKREQUIRED: "Puesto se require",
      PARKINGSEATREQUIRED: "Plazas de aparcamiento se require",

      RESOURCETYPEREQUIRED: "Recurso Tipo Se requiere ",
      REQUESTOREMAILREQUIRED: "Email del Solicitante Se requiere ",
      REQUESTORNAMEREQUIRED: "Solicitante Nombre  Se requiere",
      TIMEDURATION: "Duración",
      DESKS: "Puestos",
      REQUESTORNAME: "Solicitante",
      REQUESTOREMAIL: "Email del Solicitante",
      SUBJECT: "Asunto",
      BOOK: "Reservar",
      CAR: "vehículo",
      CARS: "vehículos",
      SUBJECTISREQUIRED: "Asunto Se requiere ",
      ADDUSERS: "Agregar usuarias",
      ADDUSER: "Agregar Usuario",
      ADDVISITORS: "Agregar visitantes",
      PARKINGSEATS: "Plazas de Aparcamiento",
      CATERRING: "VATERING",
      QUANTITY: "La cantidad",
      MOBILEEQUIPMENT: "Equipos Móviles",
      ITSUPPORT: "Soporte de TI",
      CATERINGDESCRIPTION: "Descripción del catering",
      MOBILEEQUIPMENTDESCRIPTION: "Descripción de Equipos Móviles",
      ITSUPPORTDESCRIPTION: "Descripción del soporte de TI",
      SPECIALSERVICE: "Servicios Especiales ",
      SPECIALSERVICEDESCRIPTION: "Descripción de Servicios Especiales ",
      CANCEL: "Cancelar",
      BACK: "Volver",
      EQUIPMENT: "Equipos",
      STARTDATEISREQUIRED: "Se requiere la fecha de inicio",
      ENDDATEISREQUIRED: "Se requiere la fecha de finalización",
      STARTTIMEISREQUIRED: "Se requiere la hora de inicio",
      ENDTIMEISREQUIRED: "Se requiere la hora de finalización",
      ROOMS: "Salas ",
      DESCRIPTION: "Descripción",
      CLEANING: "Limpieza",
      CLEANINGDESCRIPTION: "Limpieza Descrición",
      CHECKROOMAVAILABLITY: "Consultar disponibilidad de habitaciones",
      EDITBOOKING: "Editar Reserva",
      VIEWBOOKING: "Ver Reserva",
      CLOSE: "Cerrar",

      COMPANY: "Empresa",
      VISITORNAME: "Nombre del visitante",
      DRIVER: "Conductor",
      LICENSEPLATE: "Matrícula",
      USAGETYPE: "Usuario",
      ALLDAY: "Todo el día",
      CAPACITY: "Capacidad",
      EDIT: "Editar",
      EMPLOYEE: "Empleado",
      VISIT: "visita",
      CLIENT: "Cliente",
      SUPPLIER: "Proveedor",
      COWORKER: "compañero de trabajo",
      EXTEND: "Extender",
      END: "Finalización",
      CHECKOUT: "Checkout",
      DEBIT: "Débito",
      YES: "Sí",
      NO: "No",
      CHARGINGCAR: "Estación de Carga",
      CHARGINGCARS: "Charging Cars",
      CHARGINGCARUSAGE: "Charging Car Usage",
      CHARGINGCARDURATION: "Charging Car Duración:",
      QUANTITYISREQUIRED: "Insertar cantidad",

      INVALIDSTARTTIME: "Hora de Inicio Inválida",
      INVALIDENDTIME: "Hora de Finalización Inválida",
      AREYOUSUREYOUWANTTOACTIVATE: "¿Estás seguro de que deseas activar?",
      AREYOUSUREYOUWANTTODEACTIVATE: "¿Estás seguro de que deseas desactivar?",
      AREYOUSURE: "¿Estás seguro?",
      AREYOUSUREYOUWANTTODELETE: "¿Estás seguro/a de que quieres borrar?",
      ALLOWBOOKING: "Are you sure, You want to allow the booking?",
      DENYBOOKING: "Are you sure, You want to deny the booking?",
      CREATEVISITOR: "Crear Visitante",
      ORDERMOBILEEQUIPMENT: "¿Tiene intención de solicitar el equipo",

      //new
      DELETE: "Eliminar",
    },
    DASHBOARD: {
      FROM: "De",
      TO: "A",
      NOWINUSE: "Ahora en uso",
      FREEROOMS: "Habitaciones libres",
      FREEDESKS: "Escritorios libres",
      FREEPARKINGSEATS: "Asientos de estacionamiento gratuitos",
      TODAY: "Hoy",
      RESERVATIONSOFROOMS: "Reservas de Habitaciones",
      RESERVATIONSOFDESKS: "Reservas de escritorios",
      RESERVATIONSOFPARKINGSEATS: "Reservas de plazas de aparcamiento",
      USERSMISSEDCHECKIN: "Los usuarios no se registraron",
      NORECENTCHECKIN: "Sin registro reciente",
      CURRENTMONTH: "Mes actual",
      RESERVATIONSPERROOM: "Reservas por habitacion",
      RESERVATIONSPERDESK: "Reservas por escritorio",
      PARKINGSEATSRESERVATIONS: "Reservas de plazas de aparcamiento",
      RESERVATIONSPERUSER: "Reservas por usuario",
      MISSINGRESERVATIONS: "Reservas faltantes",
      TIMEOFRESERVATIONSPERUSER: "Tiempo de reservas por usuario",
      TIMEOFRESERVATIONSPERROOM: "Tiempo de reserva por habitación",
      TIMEOFRESERVATIONSPERDESK: "Tiempo de reserva por escritorio",
      TOTALCOSTPERUSER: "Costo total por usuario",
      DOWNLOADASCSVFILE: "Descargar como archivo CSV",
    },
    USERSETTINGS: {
      UPLOADCSV: "Subir CSV",
      IMPORTFROMLDAP: "Importar desde LDAP",
      AZUREACTIVEDIRECTORY: "Azure Active Directory",
      EDIT: "Edit",
      DELETE: "Eliminar",
      BUILDINGSETTINGS: "Building Settings",
      SSO: "SSO",
      ADD: "Agregar",
      NAME: "Nombre",
      EMAIL: "Email",
      LOCATION: "Ubicaciones",
      ROLE: "Rol",
      ACTION: "Acción",
      FILTER: "Filtrar",
      CSVFILE: "Archivo CSV",
      DOWNLOADTEMPLATE: "Descargar Plantilla",
      UPLOAD: "Subir",
      NODATAFOUND: "Datos no encontrados",
      LDAPSERVER: "Servidor LDAP",
      PORT: "Porta",
      DISABLETLS: "Desactivar TLS  ",
      IMPORT: "Importar",
      CANCEL: "Cancelar",
      USERNAME: "Nombre de usuario",
      PASSWORD: "Contraseña",
      CHECKCONNECTION: "Verifica la Conexión ",
      LDAPSERVERBASE: "Base del servidor LDAP",
      LDAPSEARCHFILTER: "Filtro de búsqueda LDAP",
      DEFAULTADUSERMAILBOX:
        "Filtro de buzón de correo de usuario de AD predeterminado",
      CUSTOMLDAPFILTER: "Filtro LDAP personalizado",
      LDAPRFIDATTRIBUTE: "Atributo LDAP RFID (opcional)",
      COUNTRY: "País",
      ADDUSER: "Agregar Usuario",
      EDITUSER: "Editar Usuário",
      DELETEUSER: "Apagar Usuário",
      CLOSE: "Cerrar",
      ADDROLES: "Agregar roles",
      ROLENAME: "Nombre de rol",
      NAMEISREQUIRED: "Nombre se require",
      ACCESSRIGHTS: "Permisos",
      SELECTALL: "Seleccionar todo",
      SELECTROLE: "-- Seleccionar Rol --",
      ROLEISREQUIRED: "Rol Se requiere",
      EDITUSERROLE: "Editar Rol de Usuario ",
      SAVE: "Guardar",
      RESOURCERIGHTS: "Resource Rights",
      RESOURCEISREQUIRED: "Resource is required",
      SELECTALLMEETROOM: "Select All Meeting Room",
      SELECTALLDESK: "Select All Desk",
      SELECTALLPARKINGSEATS: "Select All Parking Seats",
      SELECTALLCHARGINGCAR: "Select All Charging Car",
      SELECTALLCAR: "Select All Car",
    },
    USERACCESSRIGHTS: {
      CLOSE: "Cerrar",
      EDITROLES: "Editar Rol",
      BOOKABUILDING: "Reserva un edificio",
      BOOKADESK: "Reservar un escritorio",
      ORDERCATERING: "Pedido de catering",
      ENDABOOKING: "Finalizar una reserva",
      ACTIVATEINACTIVATE: "Activar / desactivar salas de reuniones",
      PARKINGCHECKOUT: "Salida de estacionamiento",
      ACTIVATEINACTIVATEDISPLAYS: "Activar / desactivar pantallas",
      BOOKAFLOOR: "Reservar un piso",
      BOOKAPARKINGSEATS: "Reserve un asiento de estacionamiento",
      ORDERMOBILEEQUIPMENT: "Solicitar equipos móviles",
      DELETEABOOKING: "Eliminar una reserva",
      ACTIVATEINACTIVATEDESK: "Activar / desactivar escritorios",
      ACTIVATEINATIVATEKIOSKS: "Activar / desactivar quioscos",
      ORDERSPECIALSERVICES: "Solicitar servicios especiales",
      BOOKAROOM: "Reservar una habitación",
      ORDERITSERVICES: "Solicitar servicios de TI",
      EDITABOOKING: "Editar una reserva",
      EXTENDABOOKING: "Ampliar una reserva",
      ACTIVATEINACTIVATEPARKINGSEATS:
        "Activar / Desactivar asientos de estacionamiento",
      ACTICATEINACTICATEVIEWPOINTS: "Activar / desactivar ViewPoints",
    },
    LOGOCONFIGURATION: {
      ENABLELOGOCHANGES: "Habilitar cambios en el  Logo",
      UPLOADLOGO: "Subir Logo",
      URL: "URL",
      OR: "(O)",
      SAVE: "Guardar",
    },
    REPORT: {
      LOCATION: "Ubicaciones",
      ROOMS: "Salas",
      SERVICES: "Servicios",
      NOSERVICEDATAAVAILABLE: "No hay datos de servicio disponibles",
      LOCATIONISREQUIRED: "Ubicaciones Se requiere ",
      ROOMSISREQUIRED: "Subir logo Se requiere ",
      SELECT: "--Seleccione--",
      DAMAGED: "¿Estás seguro de que el equipo está dañado?",
      CONFIRM: "Confirmar",
      FIX: "¿Está seguro de que se ha reparado el equipo?",
      OBSERVATION: "Comentarios",
      OBSERVATIONPLACEHOLDER: "Insertar Comentarios",
      BUILDING: "Building",
      FLOOR: "Floor",
    },
    MONTH: {
      JANUARY: "de Enero de,",
      FEBRUARY: " de Febrero de,",
      MARCH: "de Marzo de,",
      APRIL: "de Abril de,",
      MAY: " de Mayo de,",
      JUNE: " de Junio de,",
      JULY: "de Julio de,",
      AUGUST: "de Agosto de,",
      SEPTEMBER: "de Septiembre de,",
      OCTOBER: "de Octubre de,",
      NOVEMBER: "de Noviembre de,",
      DECEMBER: "de Diciembre de,",
    },

    SIDENAVBAR: {
      MYPROFILE: "Mi perfil",
      CHANGEPASSWORD: "Cambiar la Contraseña",
      CURRENTPASSWORD: "Contraseña Atual",
      NEWPASSWORD: "Nueva Contraseña",
      VERIFYPASSWORD: "Confirmar Contraseña",
      CONFIRMPASSWORD: "Confirmar Contraseña",
      SAVECHANGES: "Guardar Cambios",
      SIGNOUT: "Cerrar sessión",
      USERPROFILE: "Mi Perfil",
      HI: "Hola,",
    },

    ADDCONFIGUREADMIN: {
      COMPANYNAME: "Nombre de la Empresa",
      ENTERCOMPANYNAME: "Introducir Nombre de la Empresa",
      COMPANYNAMEISREQUIRED: "Nombre de la Empresa Se requiere campo",
      CONTACTNAME: "Nombre de Contacto",
      ENTERCONTACTNAME: "Introducir Nombre de Contacto",
      CONTACTNAMEISREQUIRED: " Nombre de Contacto Se requiere campo",
      PHONENUMBER: "Número de Teléfono",
      ENTERPHONENUMBER: "Introducir Número de Teléfono",
      COUNTRYISREQUIRED: "País Se requiere",
      RESELLER: "Revendedor",
      ENTERRESELLER: "Introducir Revendedor",
      ZELOCAR: "Zelo Auto",
      ZELOCAR1: "Laia Auto",

      COUNTRY: "País",
      EMAILTOREGISTRATION: "Email de Registro",
      ENTEREMAILTOREGISTER: "Introducir Email de Registro",
      TYPEOFACCOUNT: "Tipo de Cuenta",
      TYPEOFACCOUNTISREQUIRED: "Tipo de Cuenta  Se requiere",
      NUMBEROFROOMS: "Número de Salas",
      ENTERNOOFROOMS: "Introduzir Número de Salas",
      NUMBEROFROOMSDISPLAYS: " Número de Pantallas en Salas",
      ENTERNUMBEROFROOMSDISPLAYS: "Introduzir Número de Pantallas en Salas",
      NUMBEROFDESKS: "Número de Puestos",
      NUMBEROFDESKSDISPLAYS: "Número de Pantallas en Mesas",
      NUMBEROFPARKINGSPACES: "Número de Lugares de estacionamento",
      NUMBEROFSERVICESVIEWPOINTS: "Número de services Viewpoints",
      NUMBEROFKIOSKS: "Número de Kiosks",
      ACCOUNTID: "ID de la Cuenta",
      VALIDFROM: "Válido desde",
      VALIDFROMISREQUIRED: " Válido desde Se requiere",
      VALIDTO: "Válida hasta",
      VALIDTOISREQUIRED: "Válida hasta Se requiere",
      CONTACTSUPPORT: "Contactar a Soporte",
      MESSAGE: "Mensaje",
      BACK: "Volver",
      SAVE: "Salvar",
      CANCEL: "Cancelar",
      COUNDRY: "País",
      PASSWORD: "Contraseña",
      ONLINEPAYMENT: "Online-Payment",
      MRCARS: "MrCars",
      MRVISITS: "MrVisits",
      ADDCONFIGURECUSTOMERADMIN: "Add Configure Customer Admin",
      EDITCONFIGURECUSTOMERADMIN: "Edit Configure Customer Admin",
      NUMBEROFCARS: "Number Of Cars",
    },

    DASHBOARDS: {
      FROM: "desde",
      TO: "a",
      DOWNLOADCSVFILE: "Descargar archivo CSV",
      DOWNLOAD: "Descargar",
      CUSTOMERADMINS: "Administrador del Cliente",
      ACTIVE: "Activos",
      DEMOTRIALACTIVE: "Demo/Prueba (Activo)",
      NEW: "Nueva",
      LEAVING: "Dejando",
      SHOWMORE: "Ver Más",
      NUMBEROFROOMS: "Número de Salas",
      NUMBEROFDISPLAYS: "Número de Pantallas ",
      NUMBEROFDESKS: "Número de puestos",
      NUMBEROFDESKSDISPLAYS: "Número de Pantallas en Mesas ",
      NUMBEROFPARKINGSEATS: "Número de lazas de Aparcamiento",
      NUMBEROFKIOSKS: "Número de Kiosks",
      NUMBEROFSERVICESVIEWPOINTS: "Número de Viewpoints",
      NUMBEROFONLINEPAYMENT: "Número de Pago Online",
      BOOKINGS: "Reservas",
      NUMBEROFBOOKINGSDAY: "Número de Reservas por / Día",
      NUMBEROFBOOKINGSMONTH: "Número de Reservas por / Mes",
      NUMBEROFBOOKINGYEAR: "Número de Reservas por / Año",
      UPCOMINGRENEWAL: "Próxima Renovación",
      RECENTACTIVITIES: "Actividades Recientes",
      NOUPCOMINGRENEWAL: "No Upcoming Renewal",
      NORECENTACTIVITIES: "No hay actividades recientes",
    },

    CONFIGURECUSTOMERADMIN: {
      COMPANYNAME: "Nombre de la empresa",
      EMAIL: "Email",
      COUNTRY: "País",
      ACCOUNTTYPE: "Tipo de cuenta",
      VALIDTODATE: "Válida hasta Fecha ",
      ACTION: "Acción",
      ADD: "Agregar",
    },

    MYPROFILE: {
      MYPROFILE: "Mi perfil",
      CHANGEPASSWORD: "Cambiar la Contraseña",
      CURRENTPASSWORD: "Contraseña atual",
      NEWPASSWORD: "Nueva contraseña",
      VERIFYPASSWORD: "Verify Password",
      CONFIRMPASSWORD: "Confirmar contraseña",
      SAVECHANGES: "Guardar cambios",
      SIGNOUT: "Cerrar sessión",
      BACK: "Volver",
      CANCEL: "Cancelar",
      NAME: "Nombre",
      EMAIL: "Email",
      COUNTRY: "País",
      LOCATION: "Ubicaciones",
      SAVE: "Guardar",
      BUILDING: "Edificio",
      FLOOR: "Planta",
      LANGUAGE: "Language"
    },

    EMAILCONFIGURATION: {
      EMAILCONFIGURATION: "Configuración de email",
      EMAIL: "Email",
      PASSWORD: "Contraseña",
      HOSTSERVER: "Revisar Email",
      PORT: "Puerto",
      EMAILISREQUIRED: "Email Se requiere",
      ENTERYOUREMAIL: "Ingrese correo electrónico",
      PASSWORDISREQUIRED: "Password Se requiere",
      ENTERYOURPASSWORD: "Introducir la contraseña",
      ENTERPORT: "Introducir la puerta",
      PORTISREQUIRED: "Porta Se requiere",
      ENTERHOSTSERVER: "Introducir el anfitrión",
      HOSTSERVERREQUIRED: "Host Server Se requiere",
      CHECKEMAIL: "Vérifier le courrier",
      SAVE: "Guardar",
      TOEMAIL: "Al correo electrónico",
    },
    STYLESETTINGS: {
      SYSTEMSTYLE: "Estilo del sistema",
      SIDEBUTTONCOLOR: "Color del botón lateral",
      ACTIONBUTTONCOLOR: "Color del botón de acción",
      TOPTITLES: "Títulos principales",
      TEXTCOLOR: "Color de texto",
      BACKGROUNDCOLOR: "Color de fondo",
      KIOSKCHECKINSTYLE: "Estilo de check-in en quiosco",
      BACKGROUNDIMAGE: "Imagen de fondo",
      KIOSKINFORMATION: "Información del quiosco",
      SERVICESVIEWPOINTSDISPLAYINFORMATION:
        "Servicios Visualización de información de visualización de puntos de vista",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      RESTORETODEFAULT: "Restaurar a los valores predeterminados",
    },
    CONFIGURATIONBYLOCATION: {
      SEARCHHERE: "Busca Aquí…",
      COUNTRY: "País",
      LOCATION: "Ubicaciones  ",
      TIMEZONE: "Huso Horario ",
      ACTIONS: "Comportamiento",
    },

    EQUIPMENTS: {
      EQUIPMENTALIGNMENT: "Alineación de equipos",
      SEARCHHERE: "Buscar",
      ICON: "Icono",
      TITLE: "Título",
      ACTION: "Acción",
      LEFT: "Izquierdo",
      RIGHT: "Derecho",
      TOP: "Cima",
      BOTTOM: "Fondo",
      ADD: "Agregar",
      EDITEQUIPMENT: "Editar Equipo",
      EQUIPMENNAME: "Nombre del Equipo",
      SELECTEQUIPMENTICON: "Seleccione un icone",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      REQUIREDFIELD: "Campo requerido",
      ADDNEWEQUIPMENT: "Agregar Equipo Nuevo",
      DELETE: "Eliminar",
    },

    ROOMSETTINGSMATTABLE: {
      NAME: "Nombre",
      LOCATIONS: "Ubicaciones",
      FILTER: "Filtrar",
      ACTION: "Acción",
      ADD: "Agregar",
      MEETINGROOM: "Salas de Reuniones",
      DESKS: "Puestos",
      PARKINGSEATS: "Plazas de Aparcamiento",
      KIOSKS: "Kiosks",
      VIEWPOINT: "Viewpoints",
      DISPLAY: "Pantalla",
      OPENSPACE: "Espacio Abierto",
      SPACE: "Planos",
      FLOORNO: "Piso",
      CAR: "Coches",
      CROP: "Editar Espacio",
      EDIT: "Editar Plano",
      AVAILABLE: "Disponible",
      EDITMEETINGROOMTITLE: "Editar Sala de Reuniones",
      EDITDESKTITLE: "Editar Escritorio",
      EDITPARKINGSEARTITLE: "Editar Asiento de Estacionamiento",
      EDITCHARGINGCARTITLE: "Editar Coche de Carga",
      DELETECHARGINGCARTITLE: "Eliminar Coche de Carga",
      EDITKIOSKTITLE: "Editar Quiosco",
      EDITCARTITLE: "Editar Coche",
    },

    ROOMSETTINGSPARKINGSEATFORM: {
      EDITPARKINGSEAT: "Editar plazas de parcamiento",
      PARKINGSEATNUMBER: "Número de plazas de aparcamiento",
      ENTERPARKINGSEAT: "Insertar Número de plazas de aparcamiento",
      PARKINGSEATNUMBERISREQUIRED:
        "Número de plazas de aparcamiento se require",
      FLOOR: "Planta",
      USERMOBILENUMBER: "Teléfono móvil del usuario",
      ENTERMOBILENUMBER: "Insertar Teléfono móvil del usuario",
      ENTEREMAIL: "Insertar Email",
      CARBRAND: "Marca del vehículo",
      ENTERCARBRAND: "Insertar Marca del vehículo",
      PLATE: "Matrícula",
      ENTERPLATE: "Insertar Matrícula",
      MODEL: "Modelo",
      ENTERMODEL: "Insertar Modelo",
      PERMANENT: "Permanente",
      LOCATION: "Ubicaciones",
      SUBMIT: "Entregar",
      CANCEL: "Cancelar",
      FROM: "Disponible de:",
      TO: "a:",
      BACK: "Voltar",
      USEREMAIL: "Email del Usuario",
    },
    ROOMSETTINGSKIOSKFORM: {
      EDITKIOSK: "Editar Kiosk",
      NAME: "Nombre",

      ENTERKIOSKNAME: "Insertar Kiosk Nombre",
      KIOSKNAMEISREQUIRED: "Kiosk Nombre se require",
      LOCATION: "Ubicaciones",
      FLOOR: "Piso",
      ROOM: "Sala",
      DESK: "Puesto",
      LOGOUPLOADFILE: "Subir logo",
      CREATEQRCODE: "Crear Codigo QR",
      SUBMIT: "Entregar",
      CANCEL: "Cancelar",
      BACK: "Voltar",
      DESKERRORMSG: "Seleccionar pelo menos un Puesto",
      ROOMERRORMSG: "Seleccionar pelo menos una Sala",
      SERVICEERRORMSG: "Selecionar pelo menos uma Servicio",
    },

    DISPLAYMODALFORM: {
      ADDDISPLAY: "Agregar Pantalla",
      EDITDISPLAY: "Editar Pantalla",
      DISPLAYID: "ID de la Pantalla",
      DISPLAYIDISREQUIRED: "ID de la Pantalla se require",
      SERIALNO: "Número de Serie",
      SELECTMEETINGROOM: "--Seleccione Sala de Reuniones--",
      SELECTDESK: "--Seleccione Puesto--",
      SELECTCHARGINGCAR: "--Select Charging Car--",
      OS: "OS",
      TYPES: "Tipo",
      ROOMNAME: "Nombre de la Sala",
      LOCATION: "Ubicaciones",
      DESKNAME: "Nombre de la Puesto",
      SAVE: "Guardar",
      DESK: "Puesto",
      MEETINGROOM: "Sala de Reuniones",
      PARKINGSEAT: " Plazas de Aparcamiento",
      ADD: "Agregar",
      CHARGINGCAR: "Estación de Carga",
      VISITKIOSK: "Visit Kiosk",
      IMAGE: "Imagen",
    },

    OPENSPACEADDMODAL: {
      ADDOPENSPACE: "Adicionar Espacio abierto",
      EDITOPENSPACE: "Editar Espacio abierto",
      OPENSPACENAME: "Nombre del espacio abierto",
      ENTEROPENSPACENAME: "Introduzca el nombre del espacio abierto",
      OPENSPACENAMEREQUIRED: " Se requiere el nombre del espacio abierto",
      FLOOR: "Piso",
      TOTALCAPACITY: "Capacidad total",
      ENTERTOTALCAPACITY: "Insertar Capacidad total",
      PANDEMICSITUATION: "Situación Pandémica",
      BOOKINGCAPACITY: "Capacidade de Reserva",
      CLOSE: "Fechar",
      SAVE: "Guardar",
      UPDATE: "Atualizar",
    },

    ROOMSETTINGSDISPLAYMATTABLE: {
      DISPLAYID: "ID de la Pantalla",
      SERIALNO: "Número de Serie",
      TYPES: "Tipo",
      FILTER: "Filtrar",
      ROOMS: "Sala",
      DESKNAME: "Nombre de la Puestos",
      LOCATIONS: "Ubicaciones",
      ACTION: "Ação",
      DISPLAYNAME: "Nombre de la Pantalla",
      ADD: "Adicionar",
      ROOMDESKNAME: "Nombre de la Sala",
      EDITDISPLAYTITLE: "Editar Pantalla",
      DELETEDISPLAY: "Eliminar Pantalla",
    },

    ROOMSETTINGVIEWPOINTSFORM: {
      EDIDVIEWPOINTS: "Editar Viewpoints",
      NAME: "Nombre",
      ENTERVIEWPOINTSNAME: "Insertar ViewPoints Nombre",
      VIEWPOINTSNAMEISREQUIRED: "  ViewPoints Nombre  se require",
      LOCATION: "Ubicaciones",
      LOGOUPLOADFILE: "Subir logo",
      SUBMIT: "Entregar",
      CANCEL: "Cancelar",
      BACK: "Voltar",
      SERVICES: "Servicios",
    },

    ROOMSETTINGSDESKFORM: {
      EDITDESK: "Editar Puestos",
      NAME: "Nombre ",
      DESKNAMEREQUIRED: " Puestos Nombre se require",
      LOCATION: "Ubicaciones",
      HOURLYPRICE: "Precio por hora",
      FLOOR: "Planta",
      INTEGRATIONTYPE: "Tipo de integración",
      DAILYPRICE: "Precio por dia",
      WEEKLYPRICE: "Preço por semana",
      MONTHLYPRICE: "Precio por mes",
      CREATEQRCODE: "Criar Código QR",
      SUBMIT: "Entregar",
      UPDATEDSUCESSFULLY: "Atualizado com sucesso",
      WORKINGDAYS: "Días Laborales",
      SELECTEDTYPE: "Seleccione Tipo",
      STANDARD: "Estándar",
      IMAGE: "Imagen",
      EQUIPMENTS: "Equipamentos",
      PREMIUM: "Premium",
      DESCRIPTION: "Descrição",
      CANCEL: "Cancelar",
      OPENSPACENAME: "Nombre del espacio abierto",
      SELECTOPENSPACE: "--Seleccione Nombre del espacio abierto--",
      BACK: "Voltar",
      MAXIMUMSEATS: "Asientos Máximos",
      DISPLAYNAME: "Nombre de la Pantalla",
      PREMIUMUSER: "Usuário Premium",
    },

    ROOMSETTINGSMEETINGROOMFORM: {
      EDITMEETINGROOM: "Editar Sala de Reuniones",
      NAME: "Nombre",
      ENTERNAME: "Inserir Nombre",
      ROOMNAMEREQUIRED: "Sala de Reuniones Nombre se require",
      CARNAMEISREQUIRED: "¡El nombre Se requiere campo",
      EDITCAR: "Editar  ¡El ",
      CAPACITY: "Capacidad",
      PARKING: "aparcamiento",
      ENTERPARKING: "Introducir aparcamiento",
      KILOMETERS: "Kilómetros",
      ENTERKILOMETERS: "Introducir Kilómetros",
      KILOMETERS1: "Kilómetros :",
      FUEL1: "Tanque :",
      FUEL: "Tanque",
      SELECTFUEL: "--Seleccionar Tanque--",
      RESERVE: "Reserva",
      TANK1: "1/4 Tanque",
      TANK2: "medio Tanque",
      TANK3: "3/4 Tanque",
      TANK4: "Tanque lleno",

      NOTES: "Notas",

      LOCATION: "Ubicaciones",
      HOURLYPRICE: "Precio por hora  ",
      RESOURCEMAIL: "Email del Recurso",
      PASSWORD: "Contraseña",
      ENTERRESOURCEEMAIL: "Inserir Email del Recurso",
      FLOOR: "Planta",
      CAPACITY1: "Capacidad",
      ENTERFLOOR: "Inserir Planta",
      ENTERCAPACITY: "Inserir Capacidad",
      INTEGRATIONTYPE: "Tipo de integración",
      SELECTLOCATION: "--Seleccionar Ubicaciones--",
      SELECTDISPLAYNAME: "Seleccione o Nombre de la Pantalla",
      DAILYPRICE: "Precio por dia",
      WEEKLYPRICE: "Precio por semana",
      MONTHLYPRICE: "Precio por mes",
      CREATEQRCODE: "Crear Codigo QR",
      SUBMIT: "Entregar",
      UPDATEDSUCESSFULLY: "Actualizado com éxito",
      WORKINGDAYS: "Días Laborales",
      SELECTTYPE: "Seleccione Tipo",
      STANDARD: "Estándar",
      IMAGE: "Imagen",
      PROVIDERINFORMATION: "Información del proveedor",
      ENTERPROVIDERINFORMATION: "Inserir Información del proveedor ",
      EQUIPMENTS: "Equipos",
      PREMIUM: "Premium",
      DESCRIPTION: "Descripción",
      CANCEL: "Cancelar",
      DISPLAYNAME: "Nombre de la Pantalla",
      BACK: "Volver",
      PREMIUMUSER: "Uusário Premium",
      ENTERPASSWORD: "Insertar Contraseña",
      ENTERDESCRIPTION: "Insertar descripción",

      INSURANCECOMPANY: "Compañia de seguros",
      INSURANCEPOLICY: "póliza de seguros",
      VALIDUNTIL: "Válido hasta",
      TRAVELASSISTANCECONTACT: "asistencia en viaje",
      MODALITY: "Modalidad",
      PURCHASE: "Comprado",
      RENTING: "Renting",
      MAINTENANCE: "Mantenimiento",
      DOWNLOADCSVFILE: "Descargar archivo CSV",
      CLOSE: "Cerrar",
      SAVECHANGES: "Guardar Cambios",

      NAME1: "Nombre :",
      DESCRIPTION1: "Descripción :",
      LASTMAINTENANCE1: "último mantenimiento :",
      LASTMAINTENANCE: "último mantenimiento",
      CONFIGURE: "Configurar Plano",
      PREMIUMUSERPLACHOLDER: "Seleccionar Usuário Premium",
      CREATEDSUCCESSFULLY:"Creado Correctamente",
    },

    ENDUSERDASHBOARD: {
      ROOMS: "Salas",
      DESKS: "Puestos",
      PARKINGSEATS: "Plazas de Aparcamiento",
      ROOMDESKBOOKINGREQUESTS: "Solicitudes de Reserva",
      TYPE: "Tipo",
      RESOURCE: "Recurso",
      REQUESTERNAME: "Solicitante",
      STARTTIME: "Hora de Inicio",
      ENDTIME: "Hora de Finalización",
      ACTION: "Acción",
      NODATAFOUND: "Datos no encontrados!",
      CARS: "Coches",
    },

    LOCATIONCONFIGURATION: {
      ADDNEWLOCATION: "Agregar Ubicaciones Nuevo",
      UPDATELOCATION: "Actualizar Ubicaciones",
      SELECTCOUNTRY: "Seleccione País",
      ENTERLOCATION: "Añada la ubicación",
      SELECTTIMEZONE: "Seleccione huso horario",
      ADDRESS: "Domicilio",
      CHECKOUT: "Enviar correo electrónico después del check-out",
      ALL: "Todas",
      SAVE: "Guardar",
      DELETE: "Eliminar",
      CANCEL: "Cancelar",
      OR: "(o)",
      LOCATIONCONFIGURATION: "Ubicaciones",
      LOGOCONFIGURATION: "Configuración del Logo",
      ENABLELOGOCHANGES: "Habilitar cambios en el  Logo",
      UPLOADLOGO: "Subir logo",
      URL: "URL",
      REPORTING: "Reportar",
      EMAIL: "Email",
      MEETINGROOM: "Salas de Reuniones",
      DESK: "Puestos",
      CARS: "Coches",
      DISPLAYCHECKIN: "Regístrese  en la pantalla",
      GENERATEPINCODE: "Generar Código PIN",
      BOOKONDISPLAY: "Reservar en Display",
      NETWORKONDISPLAY: "Comentarios",
      SELECTTIME: "Seleccione tiempo      ",
      SELECTPREMIUMUSER: "Seleccionar usuario Premium",
      PARKINGSEATS: "Plazas de Aparcamiento ",
      PREMIUM: "Premium",
      PARKINGSEATSEMAILS: "Parking Seats Emails",
      CAREMAILS: "Car Emails",
      LABOURHOURS: "Horario laboral",
      SELECTFROMTIME: "Hora de inicio",
      HOUR: "Hora",
      SELECTENDTIME: "Hora de finalizácion",
      CLEANING: "Limpieza",
      CLEANINGTIME: "Tiempo de limpieza ",
      CLEANINGEMAILS: "Limpieza Emails ",
      MOBILEEQUIPMENT: "Equipos Móviles",
      MOBILEEQUIPMENTNAME: "Nombre del Equipos Móviles",
      EMAILS: "Emails",
      ACTION: "Acción",
      SEARCHHERE: "Buscar",
      CATERING: "Catering",
      CATERINGNAME: "Nombre del Catering ",
      ITSUPPORTSERVICE: "Soporte Informático",
      SPECIALSERVICES: "Solicitar Servicios Especiales",
      ADDSPECIALSERVICE: "Agregar Servicios Especiales",
      ADD: "Agregar ",
      ADDNEWMOBILEEQUIPMENT: "Agregar Equipos Móviles",
      EDITMOBILEEQUIPMENT: "Editar Equipos Móviles",
      DELETEMOBILEEQUIPMENT: "Delete Mobile Equipment",
      MOBILEEQUIPMENTEMAIL: "Email del Equipos Móviles",
      ADDNEWCATERING: "Agregar Catering ",
      CATERINGEMAILS: "Email del Catering",
      EDITCATERING: "Editar Catering",
      ADDNEWITSUPPORT: "Agregar Soporte Informático",
      ITSUPPORTNAME: "Nombre del Soporte Informático",
      ITSUPPORTEMAILS: "Email del Soporte Informático",
      EDITSPECIALSERVICE: "Editar Servicios Especiales",
      SPECIALSERVICENAME: "Nombre del Servicios Especiales",
      SPECIALSERVICEEMAIL: "Email del Servicios Especiales",
      ADDNEWSPECIALSERVICE: "Agregar Servicios Especiales",
      ADDSPECIALSSERVICEEMAILS: "Agregar Email del Servicios Especiales",
      NAME: "Nombre",
      PASSWORD: "Contraseña",
      BACK: "Volver",
      ADDNEWLANGUAGE: "Add New Language",
      LANGUAGE: "Language",
      EDIT: "Editar",
      UPDATELANGUAGE: "Update Language",
      EDITITSUPPORTSERVICE: "Editar Soporte Informático",
      INFORMREQUESTERABOUTSTART: "Informar al solicitante sobre el inicio",
      INFORMREQUESTERABOUTEND: "Informar al solicitante sobre el final",
      EQUIPMENT: "Equipos",
      CATERINGBOOKINGRESTRICT: "Restrição de Pedidos com menos de 24 Horas",
      SPECIALSERVICEGBOOKINGRESTRICT:
        "Restrição de Pedidos com menos de 24 Horas",
      ITSUPPORTRESTRICT: "Restrição de Pedidos com menos de 24 Horas",
      MOBILEEQUIPMENTRESTRICT: "Restrição de Pedidos com menos de 24 Horas",
      ENDBOOKINGEMAILTIME: "End Booking Email Time",
      HOURS: "Horario",
      ENDONDISPLAY: "Finalización en Display",
      EXTENDONDISPLAY: "Extender en Display",
      BUILDING: "Building",
      BUILDINGNAME: "Building Name",
      BUILDINGNAMEREQUIIRED: "Building Name is required",
      ADDBUILDING: "Add Building",
      EDITBUILDING: "Edit Building",
      DELETEMSG: "¿Estás seguro de que deseas eliminar permanentemente?",
      FLOOR: "Floor",
      FLOORNAME: "Floor Name",
      FLOORNAMEREQUIRED: "Floor Name is required",
      ADDFLOOR: "Add Floor",
      EDITFLOOR: "Edit Floor",
      BUILDINGCONFIGURATION: "Building Configuration",
      CHARGINGCAREMAIL: "Correos Electrónicos de Carga de Autos",
      CHARGINGCARSETTING: "Posto de Carregamento:",
      NORMALCHECKIN: "Normal Check In"
    },

    ACCOUTINFORMATION: {
      COMPANYNAME: "Nombre de la Empresa",
      CONTACTNAME: "Nombre de Contacto ",
      PHONENUMBER: "Número de Teléfono ",
      COUNTRY: "País",
      RESELLER: "Revendedor",
      EMAILTOREGISTRATION: "Email de Registro",
      TYPEOFACCOUNT: "Tipo de Cuenta:",
      NUMBEROFROOMS: "Número de Salas",
      NUMBEROFROOMSDISPLAYS: "Número de Pantallas en Salas",
      NUMBEROFDESKS: "Número de Puestos",
      NUMBEROFDESKSDISPLAYS: "Número de Pantallas en Mesas ",
      NUMBEROFPARKINGSPACES: "Número de plazas de aparcamiento",
      NUMBEROFSERVICESVIEWPOINTS: "Número de Viewpoints",
      NUMBEROFKIOSKS: "Número de Kiosks",
      NUMBEROFSPACE: "Número de Spaces",
      ACCOUNTID: "ID de la Cuenta",
      VALIDFROM: "Válido desde",
      VALIDTO: "Válida hasta",
      CONTACTSUPPORT: "Soporte de contactoContactar a Soporte  ",
      MESSAGE: "Mensaje",
      CLOSE: "Cerca",
      SEND: "Enviar",
    },
    LOGINGPAGE: {
      WELCOMETOMRROOMS: "Bienvenidos a Zelo Meetings",
      NEWHERE: "Nuevo aqui?",
      DEMOACCOUNT: "Cuenta Demo",
      ENTERYOURDETAILSTOCREATEYOURACCOUNT:
        "Ingrese sus datos para crear su cuenta",
      COMPANYNAME: "Nombre de empresa",
      CONTACTNAME: "Nombre de contacto",
      PHONE: "Teléfono",
      COUNTRY: "País",
      CONFIRMPASSWORD: "confirmar Contraseña",
      ACCEPTTERMSCONDITIONS: "Aceptar términos y condiciones",
      TERMSANDCONDITIONS: "Términos y condiciones",
      EMAIL: "Email",
      PASSWORD: "Contraseña",
      FORGOTPASSWORD: "¿Olvidó su contraseña?",
      DISCOVERAMAZINGWORKSPACE: "Discover Amazing Work Space",
      SERVICEVIEWPOINTS: "Viewpoints",
      KIOSKSMAPPLANTS: "Kiosk",
      ENTERYOUREMAILTORESETYOURPASSWORD: "",
      SUBMIT: "Entregar ",
      CANCEL: "Cancelar",
      SIGNIN: "Entrar",
      EMAILIDISREQUIRED: "Se requiere identificación de correo electrónico",
      PASSWORDISREQUIRED: "se requiere contraseña",
      INVALIDEMAILID: "Email inválido",
      THELOGINDETAILSAREINCORRECT:
        "Credenciales de inicio de sesión incorrectas",
      COMPANYNAMEISREQUIRED: "El nombre de la empresa es obligatorio",
      NAMEISREQUIRED: "Se requiere el nombre",
      PHONENUMBERISREQUIRED: "Se requiere el número de teléfono",
      COUNTRYISREQUIRED: "El país es obligatorio",
      EMAILISREQUIRED: "correo electronico es requerido",
      CONFIRMPASSWORDISREQUIRED: "Se requiere confirmación de contraseña",
      ACCEPTTSCSISREQUIRED: "Aceptar Ts & Cs es obligatorio",
    },
    CALENDAR: {
      TODAY: "Hoy",
      MEETINGROOMS: "Salas de Reuniones",
      DESK: "Escritorio",
      PARKINGSEATS: "Plazas de Aparcamiento",
      MONTH: "Mes",
      WEEK: "Semana",
      DAY: "Día",
      SUNDAY: "domingo",
      MONDAY: "lunes",
      TUESDAY: "martes",
      WEDNESDAY: "miércoles",
      THURSDAY: "jueves	",
      FRIDAY: "viernes",
      SATURDAY: "sábado",
      ALLMEETINGROOMS: "Todas las salas",
      ALLDESK: "Todos los puestos",
      ALLPARKINGSEATS: "Todas las plazas",
      CHARGINGCAR: "Estación de carga",
      ALLCHARGINGCAR: "Todos los puestos",
      YOUWANTTOENDTHEBOOKING: "You want to end the Booking!",
    },

    SERVICEVIEWPOINTS: {
      NAME: "Nombre",
      LOCATION: "Ubicaciones",
      ACTION: "Acción",
      FILTER: "Filtrar",
      BACK: "Volver",
    },
    SPACESERVICE: {
      SPACESERVICEADD: "Add Space",
      NAME: "Nombre",
      ADDRESS: "Domicilio",
      LOCATION: "Ubicacione",
      BUILDINGNAME: "Nombre del edificio",
      FLOORNO: "Floor No",
      IMAGE: "Imagen",
      BACK: "Volver",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      ACTION: "Action",
      NO: "No.",
    },
    SPACE: {
      SPACELIST: "Seleccionar plano",
      SELECTSPACE: "--Seleccionar plano--",
      STATUS: "Próximos Eventos",
    },
    // Space Edit Crop add function
    CROPSERVICE: {
      CONFIGURERESOURCE: "Configure Resource",
      AREANAME: "Area Name",
      RESOURCETYPE: "Resoure type",
      RESOURCE: "Resource",
      SAVE: "Guardar",
      CANCEL: "Cancelar",
      CROP: "Espacio",
      DELETE: "Borrar",
      ZOOM: "Ampliar",
      BACK: "Volver",
    },
    COMMON: {
      AREYOUSURE: "Are you sure?",
      SHOWMORE: "Más Opciones",
      SHOWLESS: "Minimizar Opciones",
      YOUWANTTODELETE: "You want to delete!"
    },

    VISITSETTING: {
      VISITSSETTINGS: "Configuración de las Visitas",
      VISITORS: "Visitantes",
      SAVE: "Guardar",
      VISITS: "Visitas",
      MANDATORYFIELDS: "Campos Obligatórios",
      RGPDSAFETYRULES: "GDPR y Reglas de Seguridad",
      ENABLERGPDANDSAFETYRULES: "Habilier GDPR y Reglas de Seguridad",
      RGPDCONDTION: "Condiciones GDPR",
      SAFETYRULES: "Reglas de Seguridad",
      CARDS: "Tarjetas",
      ENABLECARD: "Habilitar Tarjeta",
      ADDCARD: "Añadir Tarjeta",
      CARDNO: "Número y Tarjeta",
      CARDNUMBER: "Número y Tarjeta",
      ADDCARDNUMBER:"Añadir Número y Tarjeta",
      ACTION: "Acción",
      CLOSE: "Cerrar",
      UPDATECARD: "Actualizar Tarjeta",
      CARD: "Tarjeta",
      DELETECARD: "Eliminar Tarjeta",
      CHECKINCOUNT: "Check-in Activos",
      PARTIALCHECKOUTCOUNT: "Conteo de check-out parcial",
      ADDVISIT: "Añadir Visita",
      EDITVISIT: "Editar Visita", 
      SELECTDATE: "Seleccione Fecha",
      DATE:"Fecha",
      FILTER: "Filtrar",
      ADDORDER: "Registrarse Entrega",
      AREYOUSURETOREMOVECARD:"¿Confirma la entrega de la tarjeta?",
      IACCEPTEDTHECONDITION:"Acepto las Condiciones",
      IACCEPTEDTHERULE:"Acepto las Reglas",

      DELETEPERSONALDATA:"Eliminar datos personales",
      DOYOUCONFIRM:"Confirma aquí si deseas eliminar tus datos de nuestra base de datos",

      VISITOR: {
        NAME: "Nombre",
        GROUP: "Grupo",
        COMPANY: "Empresa",
        DEPTFUNCTION: "Departamento/Función",
        EMAIL: "Email",
        CONTACT: "Contacto",
        FOODRESTRICTIONS: "Restricciones Dieta",
        REMOVERGPDDATA: "Eliminar Datos RGPD",
        OBSERVATION: "Comentarios",
        PLACEHOLDER:{
          ENTERNAME:"Introducir Nombre",
          SELECT:"Elegir",
          INTEERNAL:"Interno",
          EXTERNAL:"Externo",
          ENTERCOMPANY :"Introducir Empresa",
          ENTERDEPTFUNCTION:"Introducir Departamento/Función",
          ENTEREMAIL:"Introducir Email ",
          ENTERCONTACT:"Introducir Nº de Móvil",
          ENTERFOODRESTICTIONS:"Introducir Restricciones Dietéticas",
          ENTEROBSERVATION :"Introducir Observaciones",
        },
        REQUIRED:{
          NAMEISREQUIRED:"Name is required",
          GROUPISREQUIRED:"Group is required",
          COMPANYISREQUIRED:"Company is required",
          DEPTFUNCTIONISREQUIRED:"Dept/Function is required",
          EmailIDISREQUIRED:"Email is required",
          INVALIDEMAILID:" Invalid Email id",
          EMAILIDTOLONG:"Email id should contain more than 1 less than 254 characters",
          CONTACTISREQUIRED:"Contact is required",
          FOODISREQUIRED:"Food Restrictions is required",
          OBSERVATIONISREQUIRED:"Observations is required",
        }
        // REQUIRED:{
        //   NAMEISREQUIRED:"Se requiere el nombre",
        //   GROUPISREQUIRED:"Se es  requiere grupo",
        //   COMPANYISREQUIRED:"Se requiere la empresa",
        //   DEPTFUNCTIONISREQUIRED:"Se es requiere el Departamento/Función",
        //   EmailIDISREQUIRED:"Se requiere el correo electrónico",
        //   INVALIDEMAILID:" Correo electrónico no válido",
        //   EMAILIDTOLONG:"El correo electrónico debe contener más de 1 y menos de 254 caracteres",
        //   CONTACTISREQUIRED:"Se requiere el contacto",
        //   FOODISREQUIRED:"Se  requieren restricciones alimentarias",
        //   OBSERVATIONISREQUIRED:"Se es requieren observaciones",
        // }
      },
      VISIT: {
        LOCATION: "Ubicacione",
        BUILDING: "Edificio",
        PURPOSE: "Objetivo",
        HOST: "Visitado",
        HOSTEMAIL: "Email del Visitado",
        ARRIVAL: "Llegada",
        DEPARTURE: "Salida",
        USERS : "Usuarios",
        HOTELNAME: "Nombre del Hotel",
        RESERVATIONNO: "Número de Reserva",
        OBSERVATION: "Comentarios",
        FLIGHTNO: "Número de vuelos",
        FLIGHT: "Vuelos",
        CHECKIN: "Check-In",
        CHECKOUT: "Check-Out",
        ASSIGNCARD: "Asignar Tarjeta",
        REMOVECARD: "Quitar Tarjeta",
        VISITINFO: "Información del visitante",
        HOTEL: "Hotel",
        ADDVISITOR: "Añadir Visitante",
        EDITVISITOR: "Editar Visitante",
        VIEWCHECKINCHECKOUT:"Ver Check-In and Check-Out",
        STATUS:"Estado",
        PLACEHOLDER:{
          ADDVISITOR:"Añadir Visitantes",
          SELECTALL:"Seleccionar Todo",
          SEARCH:"Buscar",
          SELECTLOCATION:"Seleccionar Ubicación",
          LOCATIONISREQUIRED:"Se Requiere Ubicación",
          SELECTBUILDING :"Seleccionar Edificio",
          SELECTPURPOSE:"Seleccionar Propósito",
          ENTERHOSTEAIL:"Introducir Email del Anfitrión", 
        },
        PARTIALCHECKIN: "Check-In Parcial",
        PARTIALCHECKOUT: "Check-Out Parcial"
      },

      ORDER: {
        NAME: "Nombre",
        VOLUMNSANDPACKAGES: "Volúmenes/Paquetes",
        CARRIER: "Transportista",
        NOTE: "Nota",
        COLLECTED:"Recogido",
        COLLECT:" Confirmar",
        COLLECTEDNOTES:"Recolectar",
        ORDERCOLLECTED:"Pedido recogido",
        NOTES: "Notas",
        ENTERYOURNOTES:"Introducir nota:",
        TYPE:"Escribe tu nota aqui...",
        DOYOUWANTTOADDNOTES:"Quieres añadir una nota a la entrega?",
        PLACEHOLDER:{
          SELECT:"Elegir",
          SEARCH:"Buscar",
          USERISREQUIRED:"Se Requiere Usuario",
          ENTERVOLUMNSPACKAGES:"Introducir Volúmenes/Paquetes",
          VOLUMNPACKAGESREQUIRED:"Se Requieren Volúmenes/Paquetes",
          ENTERNOTE:"Introducir nota",
        }
      }




    }
  },
};
